import {Component, OnDestroy, OnInit} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import {HttpService} from "../../services/http.service";
import {KeycloakService} from "../../services/keycloak.service";
import {ApiEndpoints} from "../../services/api-endpoints";


declare var $:any;

@Component({ standalone: false, 
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
})
export class AdminUsersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  list: any=[];
  p: number = 1;
  filterSearch: any;
  keywordSearch:any;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  configPagerAdminUsers: PaginationInstance = {
    id: 'admin-users-list',
    currentPage: 1,
    itemsPerPage: 10,
  };

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {

    this.httpSubscription = this.httpService.getUserList().subscribe( user => {
      for(let usr of user){
        if(usr.isHidden == undefined || usr.isHidden == "false") {
          this.list.push(usr);
        }
      }
    });


    // this.route.params.subscribe(params => {
    //   this.filterSearch = params['filterSearch'];
    //   this.keywordSearch = params['keywordSearch'];
    //   if(this.filterSearch!="Search Type" || this.keywordSearch!=null) {
    //     this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    //   }
    // });

    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
    // this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    // this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
  }

  // displayHeaderSearch(filterSearch, keywordSearch) {
  //   if(filterSearch!="Search Type" && keywordSearch!="" && filterSearch && keywordSearch) {
  //     var url = ApiEndpoints.GET_ALL_USERS;
  //     if(filterSearch=="username") {
  //       var body: any = { "username": keywordSearch };
  //     }
  //     if(filterSearch=="affiliation") {
  //       var body: any = {
  //         "username": this.username,
  //         "affiliation": keywordSearch
  //       };
  //     }
  //     this.http.post(url, body).map((res: Response) => res.json())
  //       .subscribe(
  //
  //       );
  //   }
  //   if(filterSearch!="Search Type" && keywordSearch=="") {
  //     this.router.navigate(['/admin-users']);
  //   }
  // }

  ngOnInit() {

    $(document).ready(function () {

      setTimeout(function(){
        var totalStatus = $("#admin-users-list tbody tr").length;
        var totalActive = 0;
        var totalError = 0;
        $("#admin-users-list tbody tr").each(function() {
          if($(this).find("td").eq(2).html()=="Active") {
            totalActive = totalActive +1;
          }
          else {
            totalError = totalError +1;
          }
        });
        $(".table-filter-search option").eq(0).html("All ("+totalStatus+")");
        $(".table-filter-search option").eq(1).html("Active ("+totalActive+"/"+totalStatus+")");
        $(".table-filter-search option").eq(2).html("Disconnected ("+totalError+"/"+totalStatus+")");

        $('.table-filter-search').selectpicker({
          liveSearch: true,
          maxOptions: 1
        });

      }, 200);

    });

    $(document).on("click", ".table-filter-search  .dropdown-menu .dropdown-item", function() {
      var index = $(this).attr("data-original-index");
      if(index == 0) {
        $("#admin-users-list tbody tr").each(function() {
          $(this).show();
        });
      }
      if(index == 1) {
        $("#admin-users-list tbody tr").each(function() {
          if($(this).find("td").eq(2).html()=="Active") {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        });
      }
      if(index == 2) {
        $("#admin-users-list tbody tr").each(function() {
          if($(this).find("td").eq(2).html()!="Active") {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        });
      }
    });

  }

  ngAfterViewInit() {
    $("#menu1").addClass("collapse");
    $("#menu1").prev().addClass("collapsed");
    $("#menu2").removeClass("collapse");
    $("#menu2").prev().removeClass("collapsed");
  }

  ngOnDestroy() {
    this.httpSubscription.unsubscribe();
  }

}
